/* eslint-disable no-bitwise */
Postlogin.Lesson = (function (my) {
    my.Categorizing = function () {
        const me = Postlogin.Lesson.Segment.apply(this, arguments);

        me.play_pause_enabled = false;

        const containerId = `${me.activity_type}-container-${me.segment_index}`;
        let container = null;
        const numberOfOptions = Object.keys(me.options).length;
        let numberOfCategories = 0;
        let numberMatched = 0;

        me.init = function () {
            if (me.activity_data.instructions) {
                me.help_enabled = true;
            }
            me.renderSegment();
        };

        me.renderSegment = function () {
            container = me.renderSegmentContainer();
            const segmentContainer = $('<div></div>')
                .addClass(`${me.activity_type}-container segment-content-container`)
                .attr('id', containerId);

            // set the number of options (used in css for displaying options)
            segmentContainer.attr('data-options-count', numberOfOptions);

            const items = $('<div></div>').addClass('collection items');
            const categories = $('<div></div>').addClass('collection categories');

            $.each(me.options, (i, option) => {
                const categoryHash = me.makeHash(option.hint);

                // add item
                const item = $('<div></div>')
                    .addClass(`item option-${option.activity_option_id}`)
                    .attr('data-category-hash', categoryHash)
                    .attr('data-option-id', option.activity_option_id);

                me.makeDraggable(item);

                let wrapper = $('<div></div>').addClass('wrapper');
                if (option.answer_image) {
                    item.addClass('has-image');
                    wrapper.css('backgroundImage', `url(${option.answer_image})`);
                    if (option.answer) {
                        wrapper.append(`<div class="option-text"><span>${option.answer}</span></div>`);
                    }
                } else {
                    item.addClass('text-only');
                    if (option.answer) {
                        wrapper.append(`<div class="option-text"><span>${option.answer}</span></div>`);
                    }
                }
                if (option.answer_audio) {
                    item.addClass('has-audio');
                    item.attr('data-audio', option.answer_audio);
                }

                item.append(wrapper);

                // randomize order of items (if shuffled == 1)
                if (+me.activity_data.shuffled === 1 && Math.floor(Math.random() * 2)) {
                    items.append(item);
                } else {
                    items.prepend(item);
                }

                if (typeof categories[categoryHash] === 'undefined') {
                    // add category
                    numberOfCategories++;
                    const category = $('<div></div>')
                        .addClass(`item category-${option.activity_option_id}`)
                        .attr('data-category-hash', categoryHash);
                    categories[categoryHash] = option.hint;

                    me.makeDroppable(category);

                    wrapper = $('<div></div>').addClass('wrapper');
                    if (option.hint_image) {
                        category.addClass('has-image');
                        wrapper.css('backgroundImage', `url(${option.hint_image})`);
                    } else {
                        category.addClass('text-only');
                    }
                    if (option.hint_audio) {
                        category.addClass('has-audio');
                        category.attr('data-audio', option.hint_audio);
                    }
                    if (option.hint) {
                        wrapper.append(`<div class="option-text"><span>${option.hint}: </span></div>`);
                    }
                    wrapper.append('<div class="item-list"></div>');
                    category.append(wrapper);

                    categories.append(category);
                }
            });

            segmentContainer.append(items);
            segmentContainer.append(categories);

            segmentContainer.attr('data-options-count', Object.keys(me.options).length);
            segmentContainer.attr('data-category-count', numberOfCategories);

            container.find('.aspect-wrapper').append(segmentContainer);

            // add this segment container to the page
            $('#page-container').append(container);
        };

        me.makeDraggable = function (optionItem) {
            optionItem.draggable({
                cursor: 'grabbing',
                containment: `#${containerId}`,
                scroll: false,
                start() {
                    Postlogin.Lesson.setDragging(true);
                    Postlogin.Lesson.playSoundEffect('pick_up');
                    $(this).css('cursor', 'grabbing');
                    $(this).siblings('.item').addClass('smaller');
                    $(this).parent().siblings('.collection').addClass('accepting');
                },
                stop() {
                    Postlogin.Lesson.setDragging(false);
                    $(container).find('.collection .item').removeClass('larger smaller');
                    $(container).find('.collection.categories').removeClass('accepting');
                },
                revert(droppableContainer) {
                    if (droppableContainer) {
                        const category = droppableContainer.attr('data-category-hash');
                        const itemCategory = $(this).attr('data-category-hash');
                        if (category === itemCategory) {
                            Postlogin.Lesson.playSoundEffect('correct');
                            me.acceptDrop(droppableContainer, $(this));
                            // if drop is valid i.e. draggable is dropped on a valid droppable or droppable has accepted the draggable

                            return false;
                        }
                        Postlogin.Lesson.playSoundEffect('incorrect');
                        const $item = $(this);
                        $item.addClass('incorrect');
                        setTimeout(() => {
                            $item.removeClass('incorrect');
                        }, 1000);

                        return true;
                    }

                    return true;
                },
            });
        };

        me.makeDroppable = function (optionItem) {
            $(optionItem).droppable({
                accept: '.items .item',
                hoverClass: 'highlight',
                classes: {
                    'ui-droppable-active': 'ui-state-active',
                    'ui-droppable-hover': 'ui-state-hover',
                },
                drop() {},
            });
        };

        me.makeHash = function (itemToHash) {
            let hash = 0;
            let i;
            let chr;

            if (itemToHash.length === 0) {
                return hash;
            }

            for (i = 0; i < itemToHash.length; i++) {
                chr = itemToHash.charCodeAt(i);
                hash = (hash << 5) - hash + chr;
                hash |= 0; // Convert to 32bit integer
            }

            return hash;
        };

        me.acceptDrop = function (droppable, draggable) {
            const $item = $(draggable);
            const optionId = $item.attr('data-option-id');
            const categoryHash = $item.attr('data-category-hash');

            const feedbackTitle = me.options[optionId].feedback_title;
            const feedbackAudio = me.options[optionId].feedback_audio;
            const feedbackBody = me.getOptionFeedback(optionId).feedback_body;
            numberMatched++;

            $(container)
                .find(`.item[data-option-id="${optionId}"]`)
                .each(function () {
                    $(this).draggable('disable');
                    $(this).addClass('correct used');
                });
            me.addToList(draggable, categoryHash);

            if (feedbackBody) {
                $('#beep-9-modal .content-container').addClass('correct');
                // show the option-feedback modal window
                Postlogin.Lesson.Popup.showModal({
                    title: feedbackTitle,
                    body: feedbackBody,
                    class: 'correct',
                    overlay: 'light',
                    smaller: true,
                    actions: [
                        {
                            label: 'Continue',
                            cssClass: 'btn-xl btn-success btn-continue',
                            onClick(e) {
                                e.stopPropagation();
                                Postlogin.Lesson.pauseCurrentSound();
                                if (numberOfOptions === numberMatched) {
                                    setTimeout(() => {
                                        Postlogin.Lesson.Popup.showCompletionModal(me);
                                    }, 250);
                                } else {
                                    Postlogin.Lesson.Popup.hideModal();
                                }
                            },
                        },
                        {
                            label: 'Replay <i class="fa fa-volume-up"></i>',
                            cssClass: 'btn-replay-audio btn-default pull-left',
                            onClick(e) {
                                e.stopPropagation();
                                $(this).fadeOut();
                                Postlogin.Lesson.playSound(feedbackAudio, 0, null, () => {
                                    $('#beep-9-modal .btn-replay-audio').fadeIn();
                                });
                            },
                        },
                    ],
                    onShow() {
                        $('#beep-9-modal .btn-replay-audio').hide();
                        // if there is an audio version of the text, play that file...
                        if (feedbackAudio) {
                            if (
                                Postlogin.Lesson.soundEnabled()
                                && !$(`#segment-${Postlogin.Lesson.getCurrentSegmentIndex()}`).hasClass(
                                    `dont-disable-feedback-${optionId}continue`,
                                )
                            ) {
                                $('#beep-9-modal .btn-continue').prop('disabled', true);
                            }
                            Postlogin.Lesson.playSound(feedbackAudio, 500, null, () => {
                                $('#beep-9-modal .btn-replay-audio').fadeIn();
                                $('#beep-9-modal .btn-continue').prop('disabled', false);
                                $(`#segment-${Postlogin.Lesson.getCurrentSegmentIndex()}`).addClass(
                                    `dont-disable-feedback-${optionId}continue`,
                                );
                            });
                        }
                    },
                    onHide() {
                        $('#beep-9-modal .content-container').removeClass('correct');
                    },
                });
            } else {
                Postlogin.Lesson.pauseCurrentSound();

                if (feedbackAudio) {
                    Postlogin.Lesson.playSound(feedbackAudio, 500);
                }

                if (numberOfOptions === numberMatched) {
                    setTimeout(() => {
                        Postlogin.Lesson.Popup.showCompletionModal(me);
                    }, 250);
                }
            }
        };

        me.addToList = function ($item, categoryHash) {
            $item.css('left', 'auto');
            $item.css('top', 'auto');
            const $list = $(`.categories .item[data-category-hash="${categoryHash}"] .item-list`);
            const $acceptedItem = $item.clone();
            $acceptedItem.removeClass('item used');
            $acceptedItem.addClass('accepted-item');
            $list.append($acceptedItem);
        };

        me.replay = function (forceShowHelp = false) {
            numberMatched = 0;

            // clear category item list
            $(container)
                .find('.item-list')
                .each(function () {
                    $(this).html('');
                });

            // reset each item
            $(container)
                .find('.collection.items .item')
                .each(function () {
                    $(this).removeClass('correct incorrect used');
                    $(this).animate(
                        {
                            top: 0,
                            left: 0,
                        },
                        {
                            duration: 600,
                            easing: 'easeOutBack',
                        },
                    );
                });

            // disable dragging
            $(container).find('.collection.items .item').draggable('disable');

            // show the help popup
            Postlogin.Lesson.Popup.showHelp(
                me,
                () => {
                    $(container).find('.collection.items .item').draggable('enable');
                    if (me.completed && !me.last) {
                        Postlogin.Lesson.showNextButton();
                    }
                },
                forceShowHelp,
            );
        };

        me.show = function () {
            me.setup();
            me.replay();
        };

        me.hide = function () {
            me.breakdown();
        };

        return me;
    };

    return my;
}(Postlogin.Lesson || {}));
